/*!

=========================================================
* Material Dashboard React - v1.10.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/material-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
// @material-ui/icons
import Dashboard from "@material-ui/icons/Dashboard";
import Person from "@material-ui/icons/Person";
import LibraryBooks from "@material-ui/icons/LibraryBooks";
// core components/views for Admin layout
import DashboardPage from "../src/views/Dashboard/Dashboard.js";
import TableList from "../src/views/TableList/TableList.js";
import Login from "../src/views/Login/Login.js";
import CreateCriteria from "../src/views/Criteria/CreateCriteria.js";
import WizardWelcomeScreen from "../src/views/InputData/WizardWelcomeScreen";
import Results from "../src/views/Results/Results";
import ShowCriteria from "../src/views/Criteria/ShowCriteria";
import EditCriteria from "../src/views/Criteria/EditCriteria";

const dashboardRoutes = [
  {
    path: "/dashboard",
    name: "Dashboard",
    rtlName: "لوحة القيادة",
    icon: Dashboard,
    component: DashboardPage,
    layout: "/admin",
  },
  {
    path: "/login",
    name: "Login",
    rtlName: "لوحة القيادة",
    icon: Person,
    component: Login,
    layout: "/admin",
  },
  {
    path: "/createcriteria",
    name: "Dodaj kriterijum(e)",
    rtlName: "لوحة القيادة",
    icon: Person,
    component: CreateCriteria,
    layout: "/admin",
  },
  {
    path: "/showallcriteria",
    name: "Prikaz svih kriterijuma",
    rtlName: "لوحة القيادة",
    icon: Person,
    component: ShowCriteria,
    layout: "/admin",
  },
  {
    path: "/editcriteria",
    name: "Izmjena kriterijuma",
    rtlName: "لوحة القيادة",
    icon: Person,
    component: EditCriteria,
    layout: "/admin",
  },
  {
    path: "/inputData",
    name: "Unos podataka",
    rtlName: "ملف تعريفي للمستخدم",
    icon: "content_paste",
    component: WizardWelcomeScreen,
    layout: "/admin",
  },
  {
    path: "/results",
    name: "Rezultati",
    rtlName: "قائمة الجدول",
    icon: LibraryBooks,
    component: Results,
    layout: "/admin",
  },
  {
    path: "/table",
    name: "Table List",
    rtlName: "قائمة الجدول",
    icon: "content_paste",
    component: TableList,
    layout: "/admin",
  },
];

export default dashboardRoutes;
